import {
  GET_ACCOUNT_DETAILS,
  UPDATE_ACCOUNT_DETAILS_PAYMENT_INFO,
  USER_LOGOUT
} from '../actions/types'

const initialState = {}

export default function accountDetails(state = initialState, action){
  const { details } = action

  switch (action.type) {
    case GET_ACCOUNT_DETAILS:
      return details
    case UPDATE_ACCOUNT_DETAILS_PAYMENT_INFO:
      let newState = state;
      newState.payment_info = details
      return newState
    case USER_LOGOUT:
      return initialState
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/accountDetails.js